export default {"src":"/assets/_next/static/media/badge-premium-talent.0142eb44.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};